var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import styled from "styled-components";
import id from "@irati/utils/id";
import { injectIntl } from "@irati/utils/lang";
import { connect } from "@irati/store";
import StatusType from "@irati/wallet/types/enums/Status";
import ExpanderItem from "../../../ExpanderItem";
import PrimaryDetails from "../../../PrimaryDetails";
import SecondaryDetails from "../../../SecondaryDetails/Spend";
var StyledSecondaryDetails = styled(SecondaryDetails)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-top: 10px;\n"], ["\n  margin-top: 10px;\n"])));
var Spend = /** @class */ (function (_super) {
    __extends(Spend, _super);
    function Spend() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Spend.prototype.render = function () {
        var _a = this.props, statementItem = _a.statementItem, className = _a.className, formatMessage = _a.formatMessage, wallet = _a.wallet;
        var transfer = statementItem.transfer;
        var amount = transfer.amount, spend = transfer.spend;
        var dealHeader = spend.dealHeader, dealThumbnailImage = spend.dealThumbnailImage, redemptionUuid = spend.redemptionUuid, orderTotal = spend.orderTotal;
        var primaryDetails = {
            image: dealThumbnailImage,
            title: dealHeader,
            subTitle: formatMessage({ id: "wallet.statementItem.spend.primaryDetails.subTitle" }),
            amount: amount,
            currency: wallet.currency,
            status: StatusType.SPENT
        };
        var secondaryDetails = {
            redemptionUuid: redemptionUuid,
            orderTotal: orderTotal
        };
        var idNamespace = id("spend-statement-item", this.props);
        return (React.createElement(ExpanderItem, { className: className, id: idNamespace, PrimaryElement: function () { return React.createElement(PrimaryDetails, { id: idNamespace, data: primaryDetails }); }, SecondaryElement: React.createElement(StyledSecondaryDetails, { id: idNamespace, data: secondaryDetails }) }));
    };
    return Spend;
}(PureComponent));
var mapStateToProps = function (_a) {
    var wallet = _a.wallet;
    return ({
        wallet: wallet
    });
};
export default injectIntl(connect(mapStateToProps)(Spend));
var templateObject_1;
